export const commentsConfig: any = {
  default: {
    titleGenerator: (authorName) => `${authorName} commented`,
  },
};
